<template>
  <modal
    :visible.sync="visible"
    top="10%"
    width="500px"
    :append-to-body="true"
    :title="$t('integration.conflict_resolution')"
  >
    <div class="uk-padding-small">
      <div class="mb-10">
        {{
          $t(
            'integration.the_base_conflicts_with_the_device_monitoring_point_dot__please_choose_the_following_handling_method_c'
          )
        }}
      </div>
      <el-radio-group v-model="way">
        <el-row v-if="deviceCarrierName">
          <el-radio class="mb-10" :label="1">
            {{
              $t('integration.bind_device_c__associate_to__b') +
                deviceCarrierName +
                ` - ${deviceProbeName}` +
                $t(']')
            }}
          </el-radio>
        </el-row>
        <el-row v-if="baseCarrierName">
          <el-radio class="mb-10" :label="2">
            {{
              $t('integration.bind_device_c__associate_to__b') +
                baseCarrierName +
                $t(']')
            }}
          </el-radio>
        </el-row>
        <el-row>
          <el-radio :label="3">{{
            $t('integration.bind_devices_and_disassociate_installation_points')
          }}</el-radio>
        </el-row>
      </el-radio-group>
    </div>

    <template #footer>
      <div>
        <el-button type="primary" @click="confirm">{{
          $t('integration.confirm')
        }}</el-button>
        <el-button @click="cancel">{{ $t('integration.cancel') }}</el-button>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      way: 1,
      promise: {
        resolve: null,
        reject: null
      },
      deviceCarrierName: '',
      baseCarrierName: '',
      deviceProbeName: ''
    }
  },
  methods: {
    open (params) {
      const { deviceCarrierName, baseCarrierName, deviceProbeName } = params
      this.deviceCarrierName = deviceCarrierName
      this.baseCarrierName = baseCarrierName
      this.deviceProbeName = deviceProbeName

      this.visible = true
      return new Promise((resolve, reject) => {
        // 将resolve / reject 保存到全局
        this.promise.resolve = resolve
        this.promise.reject = reject
      })
    },
    confirm () {
      this.visible = false
      this.promise.resolve(this.way)
    },
    cancel () {
      this.visible = false
      this.promise.reject()
    }
  }
}
</script>
